import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField, Box } from "@mui/material";
import { Moment } from "moment/moment";

import TableBody from "./TableBody/TableBody";
import TableHeader from "./TableHeader/TableHeader";
import { DATE_FORMAT } from "../../../../constants";
import {
  ContainerWithLoader,
  FilterAutocomplete,
  PaginationWithLimit,
} from "../../../../components/ui";
import { discountCodesLogsActions } from "../../../../reducers/discountCodesLogs";
import { APIDiscounts } from "../../../../api";
import { useDiscountCodesLogsContext } from "../../../../context";
import { DISCOUNT_CODES_LOGS_FILTERS } from "../../constants";

const ChangeLogs = (): React.ReactElement => {
  const dispatch = useDispatch();
  const [key, setKey] = useState(1);

  const { data, loading } = useSelector((state) => state.discountCodesLogs);
  const { rows, count } = data;

  const { page, setPage, limit, setLimit, sortBy, search, setSearch } =
    useDiscountCodesLogsContext();

  const handleChangeExpires = (date: Moment | null) => {
    setSearch({
      ...search,
      log_time: date ? date.format("YYYY-MM-DD") : "",
    });
  };

  const handleSetSearchParams = (name: string) => {
    setSearch({
      ...search,
      admin: name,
      new_field_value: "created",
    });
    setKey(key + 1);
  };

  useEffect(() => {
    (async () => {
      try {
        dispatch(discountCodesLogsActions.fetchRequest());
        const { data } = await APIDiscounts.getDiscountCodesLogChanges({
          limit,
          page,
          sortBy,
          contains: search,
        });
        dispatch(discountCodesLogsActions.fetchSuccess(data.logs_data));
      } catch (error) {
        dispatch(discountCodesLogsActions.fetchFailed());
      }
    })();
  }, [limit, page, sortBy, search]);

  return (
    <div className="discounts">
      <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <FilterAutocomplete
          search={search}
          setSearch={setSearch}
          filters={DISCOUNT_CODES_LOGS_FILTERS}
          clearValuesFilter={key}
        />

        <DatePicker
          label="Date"
          value={search.log_time || null}
          inputFormat={DATE_FORMAT}
          onChange={handleChangeExpires}
          renderInput={(params) => <TextField fullWidth name="log_time" {...params} />}
        />
      </Box>

      <p style={{ margin: "5px 0" }}>
        Logs found:<b>{count}</b>
      </p>

      <Box sx={{ overflowX: "scroll" }}>
        <ContainerWithLoader isLoading={loading} report={rows} noResultsMessage="There are no logs">
          <table style={{ width: "100%" }}>
            <TableHeader />
            <TableBody handleSetSearchParams={handleSetSearchParams} />
          </table>
        </ContainerWithLoader>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <PaginationWithLimit
          count={count}
          limit={limit}
          page={page}
          setLimit={setLimit}
          setPageState={setPage}
        />
      </Box>
    </div>
  );
};

export default ChangeLogs;
